<template>
  <Idea v-if="openedIdea" />
  <IdeasList v-else />
</template>

<script>
import IdeasList from '@/components/Ideas/List/index'
import Idea from '@/components/Ideas/Idea'

export default {
  data() {
    return {
      openedIdea: false,
    }
  },
  mounted() {
    this.openedIdea = !!this.$route.params.idea
  },
  watch: {
    $route() {
      this.openedIdea = !!this.$route.params.idea
    },
  },
  components: {
    IdeasList,
    Idea,
  },
}
</script>
